import { delegate } from 'tippy.js';
import 'tippy.js/dist/tippy.css';
//we use custom style
//import 'tippy.js/themes/light.css';
import { tooltipFnMap } from '@/directives/v-xtooltip';

import type { Instance as TippyInstance } from 'tippy.js';

export function initXTooltip(): void {
    delegate('body', {
        target: '[data-tooltip]',
        allowHTML: true,
        touch: false,
        delay: [700, 0],
        placement: 'top',
        content: '',
        //tippy cached content, need to reset content in onShow
        /*content(reference) {
            const fn = tooltipFnMap.get(reference as HTMLElement);
            return typeof fn === 'function' ? fn() : '';
        },*/
        onShow(instance: TippyInstance) {
            const isDark = localStorage.hasOwnProperty('isDark') ? JSON.parse(<string>localStorage.getItem('isDark')) : false;

            const el = instance.reference as HTMLElement;
            const fn = tooltipFnMap.get(el);

            instance.popper.children[0].classList.remove('v-theme--light');
            instance.popper.children[0].classList.remove('v-theme--dark');

            instance.popper.children[0].classList.add(isDark ? 'v-theme--dark' : 'v-theme--light');

            const attr = el.getAttribute('data-tooltip');

            if (attr) {
                instance.setContent(attr);
                return;
            }

            if (typeof fn === 'function') {
                try {
                    instance.setContent(fn());
                } catch (e) {
                    console.warn('v-xtooltip error:', e);
                    instance.setContent('');
                }
            }
        },
    });
}
